import { makeStyles } from "@material-ui/core/styles";
import { isiOS, isWeb } from "../../../utils/utility";
import { fontClasses } from "../../../fontStyles";

const useMobileStyles = makeStyles((theme) => ({
  closeButton: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&:active': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    "& svg": {
     
      "& path": {
      fill: theme.palette.primary.mainHeading,
    }
    }
  },
  schedulesBox: {
    marginBottom:'16px',justifyContent: 'space-between', display: 'flex', alignItems: 'center', width: '100%'
  },
  schedulesContainer: {
    padding: "16px",
    borderRadius: "8px",
    background: theme.palette.primary.iqAirSettingsCardColor,
  },
  scheduleLegendContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap:' 4px',
    justifyContent: 'space-between',
  },
  scheduleLegendItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  scheduleLegendItemThreePerRow: {
    flex: "0 0 calc((100% - 32px) / 3)",
    maxWidth: "calc((100% - 32px) / 3)",
  },
  scheduleLegendSwatch: {
    width: "12px",
    height: "12px",
    borderRadius: "3px",
    display: "inline-block",
  },
  scheduleLegendText: {
    ...fontClasses.body1,
    color: `${theme.palette.primary.mainText} !important`,
    fontSize: isWeb() ? "16px !important" : "12px !important",
    lineHeight: isWeb() ? "24px" : "16px",
    margin: 0,
  },
  IQAirNameContainer: {
    backgroundColor: isWeb() ? '#fafafb' : theme.palette.primary.background,
    height: isWeb() ? "unset" : "100%",
    padding: "0 20px",
    "& .ChargerSettingContainer:first-child": {
      marginTop: isiOS() ? "calc(64px + env(safe-area-inset-top))" : "64px",
    },
  },
  addPointer: {
    cursor: 'pointer'
  },
  optionBox: {
    padding: "0 12px",
    background: "#fff",
    borderRadius: "5px",
    width: "111px",
    position: "absolute",
    right: " -8px",
    top: "36px",
  },
  dropdownContainer: {
    position: "relative",
  },
  labelBox: {
    padding: "12px",
    borderBottom: "1px solid grey",
    ...fontClasses.body1,
  },
  onForText: {
    ...fontClasses.body1,
  },
  cardText: {
    ...fontClasses.graphLabel1,
    color: '#A9A9AA'
  },

  lastLabelBox: {
    borderBottom: "none",
  },
  tempCardBox: { ...fontClasses.graphLabel1, display: "flex", alignItems: "center", marginTop: "8px", color: '#6B7073' },
  tempCardBx: { position: "relative", marginTop: '10px' },

  tempCard: {
    padding: "16px",
    borderRight: "1px solid #BABEC3",
    display: "flex",
    flexDirection: "column",
    flex: '1',
    alignItems: "center",
  },
  tempContollerCard: {
    flex: '2',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  heatCoolSetPoint: {
    gap: '20px'
  },
  tempCardVal: { fontSize: "32px", color: '#6B7073', fontWeight: "400" },
  tempCardUnit: {
    fontSize: "10px",
    position: "absolute",
    top: "-8px",
    right: "-10px",
  },

  selectBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "55px",
    borderBottom: "1px solid grey",
    alignItems: "center",
  },
  IQCard: {
    borderRadius: "8px",
    background: theme.palette.primary.cardBackground,
    boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.10)",
    padding: isWeb() ? "24px" : "16px",
  },
  InnerCards: {
    background: theme.palette.primary.iqAirSettingsCardColor,
  },
  cardWithLabel: {
    padding: isWeb() ? '24px 0 0' : '16px 0 0'
  },
  energyModesLearnMoreCard: {
    display: "flex",
    alignItems: "center",
    background:  theme.palette.tertiary.learnMoreBgv,
    borderRadius: "8px",
    boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.10)",
    padding: isWeb() ? "16px" : "14px 16px",
    cursor: "pointer",
  },
  energyModesLearnMoreContent: {
    display: "flex",
    alignItems: "center",
    gap: isWeb() ? "12px" : "10px",
  },
  energyModesLearnMoreIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& svg': {
      width: isWeb() ? "16px" : "14px",
      height: isWeb() ? "16px" : "14px",
    },
  },
  energyModesLearnMoreText: {
    ...fontClasses.body1,
    color: "#01B5DE !important",
    fontSize: isWeb() ? "16px !important" : "12px !important",
    fontWeight: "500",
    lineHeight: isWeb() ? "24px" : "16px",
  },

  IQAirNameInput: {
    marginTop: isWeb() ? '0px' : isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
  },
  IQAirMode: {
    paddingBottom: "0",
    ...fontClasses.title2,
    paddingRight: isWeb() ? '48px' : '16px',
    paddingLeft: '16px'
  },
  //  setPointBox:{paddingBottom: "16px",},
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  setpointLabel: {
    fontSize: isWeb() ? '12px' : '10px',
    color: `${theme.palette.tertiary.commonText}`,
    position: 'relative',
    marginBottom: isWeb() ? '8px' : '2px',
    textAlign: 'center'
  },
  card: {
    backgroundColor: `${theme.palette.tertiary.sheetContainer} !important`,
    fontWeight: "400",
    color: `${theme.palette.tertiary.cardText} !important`,
    "& .MuiCardContent-root": {
      paddingBottom: "16px !important",
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
  cardContainer: {
    borderBottom: "1px solid #d8dcde",
    marginBottom: "16px",
    paddingBottom: "16px",
    "&:last-child": {
      borderBottom: "none",
      marginBottom: "0",
      paddingBottom: "0",
    },
  },
  cardBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: '15px',
  },
  dFlex: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  listCardRadio: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    display: 'flex',
    alignItems: 'center',
    margin: isWeb() ? '0 0 18px 4px' : '0 0 9px 4px',
    '& svg': {
      width: isWeb() ? '16px' : '12px',
      height: isWeb() ? '16px' : '12px',
      cursor: 'pointer'
    },
    '& path': {
      '&:first-child': {
        fill: `${theme.palette.tertiary.infoIcon} !important`,
      },
      fill: `${theme.palette.primary.cardBackground} !important`,
    }
  },
  cardHeadingWithRadio: {
    margin: "2px 0 0 6px",
  },
  cardHeading: {
    ...fontClasses.title1,
    display: "flex",
    flexDirection: "row",
    fontWeight: "500",
    alignItems: "center",
    color: `${theme.palette.tertiary.titleBox} !important`,
    fontSize: isWeb() ? '20px !important' : '16px !important'
  },

  smallRadioButton: {
    "& svg": {
      width: "20px",
      height: "20px"
    }
  },
  modeHeaderContainer: {
    width: "100%",
    marginLeft: "2px",
  },
  selectedRadioOption: {
    marginBottom: '16px'
  },
  disableRadio: {
    opacity: "0.6",
  },
  description: {
    ...fontClasses.body1,
    color: `${theme.palette.secondary.subHeading} !important`,
    margin: isWeb() ? '12px 25px 0' : '0 29px',
    fontSize: isWeb() ? '16px !important' : '12px !important'
  },
  dividerBorderColor: {
    width: '100%',
    backgroundColor: `${theme.palette.primary.dashedBorderColor} !important`,
  },
  sliderContainer: {
    background: theme.palette.primary.iqAirSettingsCardColor,
    margin: '16px 0px',
    borderRadius: '8px',
    padding: '16px',
  },
  dFlexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  sliderHeader: {
    ...fontClasses.body1,
    color: `${theme.palette.primary.mainHeading} !important`,
    fontSize: isWeb() ? '16px !important' : '12px !important',
    fontWeight:'500'
  },
  unit: {
    fontSize: '10px !important'
  },
  setpointArrow: {
    width: 0,
    height: 0,
    borderLeft: isWeb() ? '6px solid transparent' : '5px solid transparent',
    borderRight: isWeb() ? '6px solid transparent' : '5px solid transparent',
    borderTop: isWeb() ? '9px solid #BABEC3' : '8px solid #BABEC3',
    margin: isWeb() ? '4px auto 0' : '0 auto',
    position: 'relative',
    left: isWeb() ? '-3px' : 0
  },

  modeCard: {
    display: "flex",
    // padding: isWeb() ?"8px 24px 0" :"0px 24px",
    justifyContent: "space-around",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: isWeb() ? "64px" : "40px",
    // background: theme.palette.primary.iqAirSettingsCardColor,
  },
  inputField: {
    width: "100%",
    "& .MuiInputLabel-root": {
      ...fontClasses.body1,
      fontSize: isWeb() ? '16px !important' : '12px !important',
      color: theme.palette.tertiary.inputLabel
    },
    '& #iqAirName, & #iqAirPresetName': {
      ...fontClasses.body2,
      fontSize: isWeb() ? '16px' : '12px',
      color: theme.palette.primary.heading,
      borderBottom: `1px solid #c6c8ca`
    }
  },
  iconLayout: {
    display: "flex",
    width: isWeb() ? "64px" : "44px",
    height: isWeb() ? "64px" : "44px",
    padding: "4px 8px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    flexShrink: "0",
    aspectRatio: "1/1",
    textTransform: "capitalize",
    ...fontClasses.body2,
    fontSize: isWeb() ? '16px' : '12px',
    color: theme.palette.tertiary.lightColor,
    '& svg': {
      width: isWeb() ? "32px" : "24px",
      height: isWeb() ? "32px" : "24px",
    }
  },
  selected: {
    borderRadius: "50%",
    border: `1px solid ${theme.palette.primary.iqAirSettingsCardIconBorder}`,
    background: theme.palette.primary.iqAirSettingsCardIconBg,
    boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.10)",
    "&.tempMode-OFF svg path": {
      stroke: "#FFF",
    }
  },
  selectedMode: {
    "& path": { stroke: '#F37320' }
  },
  cardCaption: {
    ...fontClasses.caption,
    color: `${theme.palette.tertiary.commonText} !important`,
    fontSize: isWeb() ? "16px" : "12px",
    marginBottom: isWeb() ? '16px' : '12px',
    display: 'flex',
    gap: '2px',
    alignItems: 'center',
    fontWeight: 700,
  },
  cardInnerLabel: {
    ...fontClasses.body2,
    color: `${theme.palette.primary.mainHeading} !important`,
    marginBottom: '12px',
    fontSize: isWeb()?"16px !important" :"10px !important",
  },
  setpointValueContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '12px'
  },
  setpointValueText: {
    ...fontClasses.body2,
    fontWeight: '500 !important',
    lineHeight: isWeb() ? '52px' : '34px',
  },
  heatSetpointLight: {
    color: '#F37320 !important',
  },
  heatSetpointDark: {
    color: '#F8A469 !important',
  },
  coolSetpointLight: {
    color: '#01B5DE !important',
  },
  coolSetpointDark: {
    color: '#6DD8EE !important',
  },
  setpointSeparator: {
    ...fontClasses.body2,
    color: `${theme.palette.tertiary.commonText} !important`,
    fontWeight: '400 !important',
    lineHeight: isWeb() ? '52px' : '34px',
  },
  subHeading: {
    marginBottom: "16px",
    color: `${theme.palette.primary.heading} !important`,
    fontWeight: "500",
    fontSize: isWeb() ? '20px' : '16px',
  },
  modeCardOn: {
    borderRadius: '6px',
    justifyContent: 'center',
    // padding:'16px 0px'
    marginTop: '20px'
  },
  iqAirContainerCard: {
    overflowX: 'auto',
  },
  singleSetPoint: { gap: 'unset', },
  onForBox: {
    width: "113px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  dropDownHours: {
    width: "55px",
  },
  rootDropDownHours: {
    width: "100%",
  },
  iqAirSettingFooter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: isWeb() ? 'center' : 'start',
    marginTop: '34px',
    gap: '12px',
  },
  applySettingConsentContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    "& .MuiButtonBase-root": {
      padding: '0px 4px 0px 0px',
    },
    "& input": {
      position: "absolute",
      top: "12px",
      left: "12px"
    },
    "& .MuiSvgIcon-root": {
      fill: theme.palette.primary.text,
    },
    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
      fill: "#01B5DE !important",
    },
  },
  applySettingConsentDesc: {
    ...fontClasses.body1,
  },
  sliderWrapper: {
    width: "100%",
    margin: '16px 0'
  },
  autoComfortRow: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
  },
  autoSetpointLabels: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: isWeb() ? '4px' : '2px',
  },
  autoHeatSetpointLabel: {
    textAlign: 'right',
    paddingRight: isWeb() ? '8px' : '6px',
  },
  autoCoolSetpointLabel: {
    textAlign: 'left',
    paddingLeft: isWeb() ? '8px' : '6px',
  },
  autoHeatSetpointArrow: {
    marginRight: 0,
    marginLeft: 'auto',
  },
  autoCoolSetpointArrow: {
    marginLeft: 0,
    marginRight: 'auto',
  },
  autoComfortSegment: {
    flex: 1,
    minWidth: 0,
  },
  autoLabelGap: {
    width: '20px',
    flexShrink: 0,
  },
  autoComfortGap: {
    width: '40px',
    marginLeft: '-10px',
    marginRight: '-10px',
    flexShrink: 0,
    height: '6px',
    backgroundColor: '#E6E6E6',
    marginTop: '7px',
    zIndex: 1,
  },
  autoHeatSlider: {
    "&.rs__wrapper .rs__track.rs__track-0": {
      backgroundColor: "#E6E6E6 !important",
      borderRadius: "999px !important",
    },
    "&.rs__wrapper .rs__track.rs__track-1": {
      backgroundColor: "#F37320 !important",
      boxShadow: "none !important",
      borderRadius: "999px !important",
      right: "9px !important"
    },
    "&.rs__wrapper .rs__thumb.rs__thumb-0": {
      backgroundColor: "#F37320 !important",
    },
    "&.rs__wrapper .rs__thumb": {
      fontSize: "0px",
    },
    "&.rs__wrapper .rs__mark:last-of-type::after": {
      backgroundColor: "transparent !important",
    },
  },
  autoCoolSlider: {
    "&.rs__wrapper .rs__track.rs__track-0": {
      backgroundColor: "#01B5DE !important",
      borderRadius: "999px !important",
      left: "9px !important",
    },
    "&.rs__wrapper .rs__track.rs__track-1": {
      backgroundColor: "#E6E6E6 !important",
      boxShadow: "none !important",
      borderRadius: "999px !important",
      right: "5px !important"
    },
    "&.rs__wrapper .rs__thumb.rs__thumb-0": {
      backgroundColor: "#01B5DE !important",
    },
    "&.rs__wrapper .rs__thumb": {
      fontSize: "0px",
    },
    "&.rs__wrapper .rs__mark:first-of-type::before": {
      backgroundColor: "transparent !important",
    },
  },

  button: {
    borderRadius: "8px",
    width: isWeb() ? '440px' : '100%',
    color: '#6B7073',
    textAlign: 'center',
    background: "#BABEC3",
    padding: '12px 0',
    pointerEvents: 'none',
    cursor: 'pointer'
  },
  aiCoolBox: {
    ...fontClasses.body1,
    color: `${theme.palette.primary.mainHeading}`,
    fontSize: isWeb() ? '16px !important' : '12px !important'
  },
  enableButton: {
    color: '#FFF',
    pointerEvents: 'auto',
    background: "#01B5DE",
  },
  errorMsg: {
    color: '#f44336 !important',
    fontSize: '12px',
    lineHeight: '16px',
    margin: '6px 0px 0px 0px',
    fontWeight: '400',
  },
  iqAirTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    "& span:last-child": {
      fontSize: '15px',
      color: 'rgb(111, 110, 142)',
      margin: '5px 0px',
      fontWeight: '400'
    },
  },
  manual_mode_description: {
    ...fontClasses.body1,
    color: '#6B7073',
    fontSize: isWeb() ? "16px !important" : "12px !important",
  },
  list: {
    paddingLeft: '20px',
    margin: isWeb() ? '8px 0 16px' : '2px 0 8px'
  },
  listItem: {
    listStyleType: 'disc',
    '&::marker': {
      color: '#6B7073'
    }
  },
  smart_description_main: {
    paddingBottom: isWeb() ? "16px" : '8px',
  },
  pedding_bottom: {
    paddingBottom: "16px",
  },
  separator: {
    borderTop: `1px solid ${theme.palette.primary.iqAirSettingsCardIconBorder}`,
    paddingTop: isWeb() ? "16px" : '8px'
  },
  subTitle: {
    ...fontClasses.title1,
    fontSize: isWeb() ? "20px !important" : "16px !important",
  },
  comfort_color: {
    color: `${theme.palette.tertiary.commonText}`,
    fontWeight: 500
  },
  dualTempSlider: {
    "&.rs__wrapper .rs__track.rs__track-0": {
      backgroundColor: "#F37320 !important",
    },

    "&.rs__wrapper .rs__track.rs__track-1": {
      backgroundColor: "#E6E6E6 !important",
    },

    "&.rs__wrapper .rs__track.rs__track-2": {
      backgroundColor: "#01B5DE !important",
    },

    "& .rs__thumb.rs__thumb-0": {
      backgroundColor: "#F37320 !important",
    },

    "& .rs__thumb.rs__thumb-1": {
      backgroundColor: "#01B5DE !important",
    },


    "&.rs__wrapper.heat .rs__track.rs__track-0": {
      backgroundColor: "#F37320 !important",
    },

    "&.rs__wrapper.heat .rs__track.rs__track-1": {
      backgroundColor: "#E6E6E6 !important",
    },

    "&.rs__wrapper.heat .rs__thumb": {
      backgroundColor: "#F37320 !important",
    },


    "&.rs__wrapper.cool .rs__track.rs__track-0": {
      backgroundColor: "#E6E6E6 !important",
    },

    "&.rs__wrapper.cool .rs__track.rs__track-1": {
      backgroundColor: "#01B5DE !important",
    },

    "&.rs__wrapper.cool .rs__thumb": {
      backgroundColor: "#01B5DE !important",
    },


    "& .rs__thumb": {
      position: "relative",
      fontSize: "0px",
    },
  },

  "@global": {
    "body.slider-dragging .rs__is-dragging .rs__thumb.rs__thumb-dragging::before": {
      content: "attr(aria-valuenow)",
      position: "absolute",
      top: "-42px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "24px",
      textAlign: "center",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "24px",
      color: "#6B7073",
      whiteSpace: "nowrap",
      pointerEvents: "none",
      zIndex: 4,
    },

    "body.slider-dragging .rs__is-dragging .rs__thumb.rs__thumb-dragging::after": {
      content: '""',
      position: "absolute",
      top: "-20px",
      left: "50%",
      transform: "translateX(-50%)",
      borderLeft: "6px solid transparent",
      borderRight: "6px solid transparent",
      borderTop: "8px solid #A9A9AA",
      pointerEvents: "none",
      zIndex: 4,
    },
  },

  // Schedule Scenes Styles
  scheduleScenesContainer: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px",
    alignSelf: "stretch",
    borderRadius: "8px",
    background: `${theme.palette.primary.background}`,
  },

  scenesSectionTitle: {
    ...fontClasses.title1,
    color: `${theme.palette.primary.mainText} !important`, 
    margin: 0,

  },

  scenesGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    justifyContent: "flex-start",
    width: "100%",
  },

  sceneCard: {
    display: "flex",
    padding: "8px 12px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flex: "0 0 calc(33.333% - 8px)",
    borderRadius: "8px",
    background: `${theme.palette.primary.cardBackground}`,
    boxSizing: "border-box",
    maxWidth: "calc(33.333% - 8px)",
    minWidth: "80px",
    overflow: "hidden",
  },

  sceneContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },

  sceneName: {
    color: `${theme.palette.primary.mainText} !important`,
    fontSize: isWeb()?"12px" :"10px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "60px",
  },

  sceneTemperature: {
    color: "#6B7073",
    fontSize: isWeb()?"12px" :"10px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "80px",
  },

  sceneIcon: {
    width: isWeb()?"16px":"12px",
    height: isWeb()?"16px":"12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  sceneTextIconPair: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: "4px",
  },

  sceneHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },

  sceneIconContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "8px",
  },



  sceneColorDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
  },

  sceneTemperatures: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
  },

  temperatureItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  temperatureLabel: {
    ...fontClasses.body2,
    fontSize: "10px",
    color: "#6B7073",
    marginBottom: "2px",
  },

  temperatureValue: {
    ...fontClasses.body2,
    fontSize: "12px",
    fontWeight: 600,
    color: "#333",
  },

  sceneModes: {
    display: "flex",
    justifyContent: "center",
  },

  modeText: {
    ...fontClasses.body2,
    fontSize: "10px",
    color: "#6B7073",
    textTransform: "uppercase",
    background: "none",
    paddingBottom: "24px",
    paddingTop: "16px",
  },

  noScenesText: {
    ...fontClasses.body2,
    fontSize: "14px",
    color: "#6B7073",
    textAlign: "center",
    padding: "20px",
  },

  // Edit Scene Popup Styles
  editScenePopup: {
    display: "flex",
    flexDirection: "column",
    // padding: "24px",
    backgroundColor: theme.palette.primary.cardBackground,
    borderRadius: isWeb() ? "8px" : "0",
    width: "100%",
    maxWidth:"100vw",
    minWidth: isWeb() ? "800px":"100vw",
    boxSizing: "border-box",
    height: isWeb() ? "90vh" : "calc(90vh - 16px)",
    maxHeight: isWeb() ? "90vh" : "calc(90vh - 16px)",
    overflow: "hidden",
  },

  roundedButton:{
    display: 'flex',
    padding: '4px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '8px',
    border: "1px solid #01B5DE",
    fontSize:isWeb() ?"14px":"12px",
    color:"#01B5DE",
    textTransform:"uppercase",
    cursor:'pointer'
  },

  popupHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #BABEC3",
    backgroundColor: theme.palette.primary.cardBackground,
    padding: "14px",
    flexShrink: 0,
    boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.06)",
    color: "#545456"
  },

  popupContent: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflowY: "auto",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
    padding: "16px",
  },

  popupTitle: {
    ...fontClasses.title1,
    fontSize: isWeb() ? "20px" : "16px",
    fontWeight: "600",
    color:`${theme.palette.primary.mainText} !important`,
  },

  closeIcon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    color: theme.palette.tertiary.lightColor,
    "&:hover": {
      color: theme.palette.primary.mainHeading,
    },
  },

  popupSection: {
    marginBottom: "24px",
    '&:last-child': {
      marginBottom: 0,
    },
  },

  sectionTitle: {
    ...fontClasses.body1,
    fontSize: isWeb() ? "16px" : "14px",
    fontWeight: "600",
    color: theme.palette.primary.mainHeading,
    marginBottom: "12px",
  },

  popupFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "32px",
    paddingTop: "16px",
    borderTop: `1px solid ${theme.palette.primary.dashedBorderColor}`,
  },

  cancelButton: {
    backgroundColor: "#BABEC3",
    color: "#6B7073",
    "&:hover": {
      backgroundColor: "#A9A9AA",
    },
  },

  saveButton: {
    backgroundColor: "#01B5DE",
    color: "#FFF",
    "&:hover": {
      backgroundColor: "#00A0C7",
    },
  },

  editSceneFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
    gap: "12px",
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.primary.dashedBorderColor}`,
    backgroundColor: theme.palette.primary.cardBackground,
  },

  editSceneCancelButton: {
    flex: 1,
    textAlign: "center",
    padding: "12px 0",
    borderRadius: "8px",
    border: "2px solid #01B5DE",
    color: "#01B5DE !important",
    backgroundColor: "transparent",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: isWeb() ? "16px" : "14px",
    "&:hover": {
      backgroundColor: "rgba(1, 181, 222, 0.1)",
    },
  },

  editSceneApplyButton: {
    flex: 1,
    textAlign: "center",
    padding: "12px 0",
    borderRadius: "8px",
    backgroundColor: "#01B5DE",
    color: "#FFF",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: isWeb() ? "16px" : "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#00A0C7",
    },
  },

  editSceneApplyButtonDisabled: {
    backgroundColor: "#BABEC3",
    color: "#6B7073",
    pointerEvents: "none",
    cursor: "default",
    "&:hover": {
      backgroundColor: "#BABEC3",
    },
  },

  // Edit Scene Popup specific overrides
  "& .editScenePopup .IQAirMode": {
    paddingRight: "16px !important",
    paddingLeft: "16px !important",
  },
  "& .editScenePopup .IQCard": {
    padding: "16px !important",
  },
  "& .editScenePopup .modeCard": {
    justifyContent: "space-around !important",
  },

splitDualTempSlider: {
  "&.rs__wrapper .rs__track.rs__track-0": {
    backgroundColor: "#E6E6E6 !important",
  },
  "&.rs__wrapper .rs__track.rs__track-2": {
    backgroundColor: "#E6E6E6 !important",
  },
  "&.rs__wrapper .rs__track.rs__track-1": {
    boxShadow: "none !important",
    background: "linear-gradient(to right, #F37320 0%, #F37320 calc(var(--auto-mid-stop, 50%) - (var(--auto-middle-gap, 84px) / 2)), #E6E6E6 calc(var(--auto-mid-stop, 50%) - (var(--auto-middle-gap, 84px) / 2)), #E6E6E6 calc(var(--auto-mid-stop, 50%) + (var(--auto-middle-gap, 84px) / 2)), #01B5DE calc(var(--auto-mid-stop, 50%) + (var(--auto-middle-gap, 84px) / 2)), #01B5DE 100%) !important",
  },
},

}));

export { useMobileStyles };
